module.exports = __webpack_public_path__ + "img/pethouse47.d816a775.jpg";